<div class="container-fluid">
    <app-submenu-tabs section="NEGOTIATIONAJILES"></app-submenu-tabs>
    <router-outlet></router-outlet>    
</div>